import { Directive, effect, input, TemplateRef, ViewContainerRef, inject, EmbeddedViewRef } from '@angular/core';

import { UserCapability } from 'identity-management';
import { CapabilitiesService } from '../../services/capabilities.service';

@Directive({
  selector: '[libHasCapability]',
  standalone: false,
})
export class HasCapabilityDirective {
  private readonly capabilitiesService = inject(CapabilitiesService);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);

  libHasCapability = input.required<UserCapability | UserCapability[]>();

  private viewRef: EmbeddedViewRef<unknown> | null = null;

  constructor() {
    effect(() => this.renderContent(this.userHasAccess(this.libHasCapability())));
  }

  private userHasAccess(capabilities: UserCapability | UserCapability[]): boolean {
    if (Array.isArray(capabilities)) {
      return capabilities.some((capability: UserCapability) => this.capabilitiesService.hasCapability(capability));
    }

    return this.capabilitiesService.hasCapability(capabilities);
  }

  private renderContent(canDisplay: boolean): void {
    if (canDisplay) {
      if (!this.viewRef) {
        this.viewRef = this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    } else {
      this.viewContainerRef.clear();
      this.viewRef = null;
    }
  }
}
